import { render, staticRenderFns } from "./OptionalInput.vue?vue&type=template&id=63074391&scoped=true&"
import script from "./OptionalInput.vue?vue&type=script&lang=js&"
export * from "./OptionalInput.vue?vue&type=script&lang=js&"
import style0 from "./OptionalInput.vue?vue&type=style&index=0&id=63074391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63074391",
  null
  
)

export default component.exports